var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-category-column col-lg-3 col-md-4 col-sm-6"},[_c('LocalisedLink',{staticClass:"sub-category",attrs:{"to":_vm.path}},[_c('TeliaCoreIcon',{staticClass:"sub-category__icon",attrs:{"name":_vm.icon,"size":"30px"}}),_c('span',{staticClass:"sub-category__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }